import React, { useContext, useCallback, useMemo} from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { withRouter } from 'react-router-dom';
import metadata from './AddlInterestComponent.metadata.json5';
import styles from './AddlInterestComponent.module.scss';
import AdditionalInterestDetails from '../AdditionalInterestDetails/AdditionalInterestDetails';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function AddlInterestComponent(props) {
    const {
            submissionVM,
            updateWizardData,
            pathUpdated,
        } = props;

        const breakpoint = useContext(BreakpointTrackerContext);
        const { onValidate } = useValidation('AddlInterestComponent');
        const modelVM = _.get(submissionVM, pathUpdated)
        const viewModelService = useContext(ViewModelServiceContext);
    
        const handleValueChange = useCallback(
            (value, changedPath) => {
                const fullPath = `${pathUpdated}.${changedPath}`;
    
                _.set(submissionVM, `${fullPath}`, value);
    
                updateWizardData(submissionVM);
            },
            [pathUpdated, submissionVM, updateWizardData]
        );
    const addAdditionalInterest = useCallback(async () => {
        
                const additionalInterestObj = {
                    tempID: EntityUtil.nextId()
                };
        
                const { _xCenter, _dtoName } = modelVM;
        
                const additionalInterestVM = viewModelService.create(additionalInterestObj, _xCenter, _dtoName);
        
                modelVM.value= modelVM.value || []
                additionalInterestVM.isValidationReq.value = true
        
                modelVM.pushElement(
                    additionalInterestVM
                );
                _.set(submissionVM, pathUpdated, modelVM)
                updateWizardData(submissionVM);
            },
                [modelVM, viewModelService, submissionVM, pathUpdated, updateWizardData]
            );


         const additionalInterestDetailsOverrides = useMemo(() => {
                const informationList = _.get(submissionVM, pathUpdated, []);
                let overrides = [];
        
                if (!_.isEmpty(informationList)) {
                    overrides = informationList?.children.map((information, index) => ({                
                        [`additionalInterestDetails${index}`]:{
                            submissionVM,
                            updateWizardData,
                            pathUpdated: `${pathUpdated}.children[${index}]`,
                            listofAdditionalInterest: pathUpdated
                        },
                    }));
                }
        
                return Object.assign({}, ...overrides);
            }, [pathUpdated, submissionVM, updateWizardData]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const overrideProps = {
            '@field': {
                showRequired: true,
                labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
            },
            additionalAccordionSet: {
                path: pathUpdated,
                data: modelVM?.value
            },
            ...additionalInterestDetailsOverrides
        };

    
        const resolvers = {
            resolveCallbackMap: {
                onValidate,
                addAdditionalInterest
            },
            resolveComponentMap: {
                additionalInterestDetails: AdditionalInterestDetails
            },
            resolveClassNameMap: styles,
        };
    
        const readValue = useCallback(
            (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
            [overrideProps, pathUpdated, submissionVM]
        );
    
        return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                // onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }

AddlInterestComponent.propTypes = wizardProps;
export default withRouter(AddlInterestComponent);